import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { TmsDashboard } from './components/TmsDashboard'
import { ExpenseDashboard } from './components/ExpenseDashboard'
import { CarWashDashboard } from './components/CarWashDashboard'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<TmsDashboard />} />
        <Route path="expense" element={<ExpenseDashboard />} />
        <Route path="carwash" element={<CarWashDashboard />} />
      </Route>
    </Routes>
  )
}

export default App
